module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i', [_vm._v("For the Members of the Aardvarks,")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i', [_vm._v("the oldest established SF-writing workshop")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i', [_vm._v("in Minneapolis and/or St. Paul")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i', [_vm._v("(We also do mysteries")]), _c('span', {
    staticClass: "Apple-converted-space"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i', [_vm._v("and doctoral dissertations.)")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('b')]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-406d0b69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section2.vue
// module id = 84
// module chunks = 0